export default {"src":"/_next/static/media/impact-europe-white.75499ba2.svg","height":91,"width":178,"blurWidth":0,"blurHeight":0};